export default __webpack_public_path__ + "static/media/packers_white.a432d686.png";